/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
/**
 * Gets the abbreviated month name (i.e. JAN, FEB, MAR) from a {@link Date} object.
 *
 * @param date - the date to format
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();const getMonthAbbr = (date: Date): string => {
  return date.toLocaleString('default', { month: 'short' }).toUpperCase()
}

/**
 * Gets the date range string for two given dates (i.e. 12-27).
 *
 * @param startDate - the start date
 * @param endDate - the end date
 */
const getDateRange = (startDate: Date, endDate: Date): string => {
  return `${startDate.getDate()}-${endDate.getDate()}`
}

export { getDateRange, getMonthAbbr }
